import { CommonModule } from '@angular/common';
import { Component, AfterViewInit, OnDestroy, ElementRef, ViewChild, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ModalSedesComponent } from '../modal-sedes/modal-sedes.component';
@Component({
  selector: 'app-contenido-incripciones',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './contenido-incripciones.component.html',
  styleUrl: './contenido-incripciones.component.scss'
})
export class ContenidoIncripcionesComponent {
  @Input() data: any;
  @ViewChild('headerContainer') headerElement!: ElementRef;
  private resizeObserver: ResizeObserver | undefined;
  constructor(public dialog: MatDialog) {

  }
  ngAfterViewInit() {
    this.resizeObserver = new ResizeObserver(() => {
      const header = this.headerElement.nativeElement;
      const imgElement = document.getElementById('img-portada-incripcion');

      if (header && imgElement) {
        // 1. Obtenemos las coordenadas reales del header en la pantalla
        const headerRect = header.getBoundingClientRect();

        // 2. Obtenemos las coordenadas del contenedor de la imagen
        const parentRect = imgElement.parentElement?.getBoundingClientRect();

        if (parentRect) {
          // 3. Calculamos la diferencia:
          // El punto donde termina el header (bottom) menos donde empieza el padre
          const topDesplazamiento = headerRect.bottom - parentRect.top;

          // 4. Aplicamos el resultado
          imgElement.style.top = `${topDesplazamiento}px`;
          imgElement.style.transform = 'translateY(-100%)';
        }
      }
    });

    this.resizeObserver.observe(this.headerElement.nativeElement);
    // También observamos el padre por si cambia de posición
    if (this.headerElement.nativeElement.parentElement) {
      this.resizeObserver.observe(document.body);
    }
  }


  clickButton(info) {
    let departments = this.data.additionalInformation.find(d => d.departments).departments;
    let data = []
     

    departments.forEach(region => {
      let redirect = (info.identifier == 'btn-contacto-sedes') ? region.whatsapp : (info.identifier == "btn-formulario-sedes") ? region.urlFormulario : "";
      data.push({ text: region.campusName, redirect });
    });
    this.dialog.open(ModalSedesComponent, { panelClass: 'custom-dialog-container-sedes', data });

  }
}
